/* LinksComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const SteveIo = require("@gluenetworks/steve_core_io");
const Renderer = require("./LinksRenderer");
const disabledStatus = ["RUNNING", "COMPLETE", "CANCELED", "ERROR", "VALIDATING", "SCHEDULED"];
class LinksComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._gameEditor = context.gameEditor;
        this._plan = this._gameEditor.getPlan();
        this._osPlanDetailsViewModel = context.osPlanDetailsViewModel;
        if (_.includes(disabledStatus, this._gameEditor._plan.status)) {
            this._isCompleted = true;
        } else {
            this._isCompleted = false;
        }
        this._context = context;
        this._switchToEditImage = context.switchToEditImage.bind(this);
        this._logger = context.logger;
        this._value = value;
        this._modalUserFeedback = context.modalUserFeedback;
        this._renderer = new Renderer(this);
        this._steveIo = new SteveIo();
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        if (this._value) {
            this._value.on(
                "PropertiesUpdated",
                (this.updateComponent = this.updateComponent.bind(this))
            );
        }
    }

    _unregisterListeners() {
        if (this._value) {
            this._value.removeListener("PropertiesUpdated", this.updateComponent);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._steveIo = undefined;
        return prom;
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }

    getValue() {
        return this.getLinks();
    }

    updateComponent(after, before) {
        if (after && before) {
            this.emit("Links", before);
        }
    }

    setLinks(newVal) {
        this._value = newVal;
    }

    getLinks() {
        return this._value;
    }

    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
    removeDevice() {
        let isGroupBy = _.get(this._value, "groupBy", null);
        let groupkey = this._value;
        let msg, ids;
        if (isGroupBy) {
            msg =
                "Are you sure you want to permanently remove all devices from " +
                groupkey.groupingValue +
                " ?";
            ids = groupkey.id;
        } else {
            msg = "Are you sure you want to delete " + groupkey.name + " from the OS Plan?";
            ids = [groupkey.id];
        }
        return this._gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: msg,
                title: "Delete",
                confirmDetails: {
                    text: "Confirm",
                    type: "destructive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            },
            () => {
                try {
                    return this._gameEditor._removeDevices(ids, isGroupBy);
                } catch (error) {
                    return error;
                }
            }
        );
    }
}

module.exports = LinksComponent;
